import { createSlice, Draft } from "@reduxjs/toolkit";
import { getUserFromToken } from "../utils/generalUtilities";

export interface UserState {
  token: string;
  id: string;
  firstname: string;
  middlename: string;
  lastname: string;
  username: string;
  emailAddress: string;
  employeeID: string;
  employerID: string;
  sootchyEmployerID: string;
  vestingScheduleName: string;
  enrolledStatus: string;
  IsDefaultPasswordChanged: string;
  isDefaultDateOfBirth: boolean | null;
}

const initialState: UserState = {
  token: "",
  id: "",
  firstname: "",
  middlename: "",
  lastname: "",
  username: "",
  emailAddress: "",
  employeeID: "",
  employerID: "",
  sootchyEmployerID: "",
  vestingScheduleName: "",
  enrolledStatus: "Unknown",
  IsDefaultPasswordChanged: "",
  isDefaultDateOfBirth: null,
};

export type User = typeof initialState;

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    addToken(
      state: Draft<typeof initialState>,
      action: { payload: string },
    ): void {
      state.token = action.payload;
    },
    addUserInformation(
      state: Draft<typeof initialState>,
      action: {
        payload: string;
      },
    ): void {
      const {
        FirstName,
        MiddleName,
        LastName,
        UserName,
        UserAccountID,
        EmailAddress,
        EmployeeID,
        EmployerID,
        SootchyEmployerID,
        VestingScheduleName,
        EnrolledStatus,
        IsDefaultPasswordChanged,
      } = getUserFromToken(action.payload);

      state.id = UserAccountID;
      state.firstname = FirstName;
      state.middlename = MiddleName;
      state.lastname = LastName;
      state.username = UserName;
      state.emailAddress = EmailAddress;
      state.employeeID = EmployeeID;
      state.employerID = EmployerID;
      state.sootchyEmployerID = SootchyEmployerID;
      state.vestingScheduleName = VestingScheduleName;
      state.enrolledStatus = EnrolledStatus;
      state.IsDefaultPasswordChanged = IsDefaultPasswordChanged;
    },

    updateDefaultPasswordStatus(state, action: { payload: string }) {
      state.IsDefaultPasswordChanged = action.payload;
    },

    updateEnrolledStatus(state, action: { payload: string }) {
      state.enrolledStatus = action.payload;
    },

    setIsDefaultDateOfBirth(state, action: { payload: boolean }) {
      state.isDefaultDateOfBirth = action.payload;
    },
  },
});

export const {
  addToken,
  addUserInformation,
  updateDefaultPasswordStatus,
  updateEnrolledStatus,
  setIsDefaultDateOfBirth,
} = userSlice.actions;
export default userSlice.reducer;
